export enum BankingDetailsEvents {
  ConfirmBankingDetailsClick = 'banking_details_confirm_click',
}
